import React from 'react';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import FloatingCallButton from '../components/FloatingCallButton';
import { Header } from '../components/sections/Header';
import { Hero } from '../components/sections/Hero';
import { BrandsGrid } from '../components/sections/BrandsGrid';
import { CommercialServices } from '../components/sections/CommercialServices';
import { InstallationPackages } from '../components/sections/InstallationPackages';
import { PromoSection } from '../components/sections/PromoSection';
import { Services } from '../components/sections/Services';
import { WhyChooseUs } from '../components/sections/WhyChooseUs';
import { About } from '../components/sections/About';
import GoogleReviews from '../components/GoogleReviews';
import ServiceAreaMap from '../components/ServiceAreaMap';
import { FAQ } from '../components/sections/FAQ';
import { CTA } from '../components/sections/CTA';
import { Contact } from '../components/sections/Contact';
import { Footer } from '../components/sections/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0A0E27]">
      <FloatingWhatsApp />
      <FloatingCallButton />
      <Header />
      <Hero />
      <BrandsGrid />
      <CommercialServices />
      <InstallationPackages />
      <PromoSection />
      <Services />
      <WhyChooseUs />
      <About />
      <ServiceAreaMap />
      <section id="testimonials" className="py-20 bg-[#0D1233]">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="inline-block bg-[#0066FF]/20 text-[#00D9FF] px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4">
              Reviews
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Trusted by Ballito Residents
            </h2>
            <p className="text-base md:text-lg text-gray-400">
              Real reviews from our satisfied customers
            </p>
          </div>
          <GoogleReviews />
        </div>
      </section>
      <FAQ />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
